import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router/index'
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import i18n from './i18n'
import ApiService from "@/state/api.service";
import vuetify from '@/plugins/vuetify'
import * as Sentry from "@sentry/vue";

import './plugins'

// API service init
ApiService.init();
Vue.config.productionTip = false
Vue.use(VueRouter)
          
Sentry.init({
  Vue,
  dsn: "https://3845d14d29138742600823b0ffd7a278@o4508660306673664.ingest.us.sentry.io/4508694200254464",
  environment: process.env.VUE_APP_ENVIROMENT,
  integrations: [
    Sentry.browserTracingIntegration({ VueRouter }),
  ],
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
